import {
  SimpleShowLayout,
  Show,
  TextField,
  NumberField,
  FunctionField,
  useTranslate,
  ReferenceField,
} from "react-admin";
import {
  DateField,
  Title,
  ShowOnlyTopToolbar,
} from "../../shared/components/index.js";
import moment from "moment";

const ShowCoupon = () => {
  const t = useTranslate();

  return (
    <Show
      title={<Title source="coupon_code" />}
      actions={<ShowOnlyTopToolbar />}
    >
      <SimpleShowLayout>
        <TextField source="coupon_code" />
        <TextField source="fuel_type" />
        <NumberField source="nominal" />
        <ReferenceField source="client_id" reference="Client" link="show">
          <TextField source="phone" />
        </ReferenceField>
        <ReferenceField source="trunc_id" reference="Trunc" link="show">
          <TextField source="id" />
        </ReferenceField>
        <TextField source="coupon_serial" />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Coupon.source.status.${record.status}`)
          }
        />
        <FunctionField
          source="previous_state"
          render={(record) =>
            record.previous_state
              ? t(`resources.Coupon.source.status.${record.previous_state}`)
              : ""
          }
        />
        <DateField source="valid_period" />
        <FunctionField
          source="begin_date"
          render={(record) =>
            record && record.begin_date
              ? moment.unix(record.begin_date / 1000).format("DD-MM-YYYY")
              : ""
          }
          label="resources.Coupon.fields.begin_date"
        />
        <FunctionField
          source="end_date"
          render={(record) =>
            record && record.end_date
              ? moment.unix(record.end_date / 1000).format("DD-MM-YYYY")
              : ""
          }
          label="resources.Coupon.fields.end_date"
        />
        <DateField source="shared_at" />
        <DateField source="reserved_until" />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowCoupon;
